module.exports.KEYS = {
    ENTER: 'Enter'
};
